import { APIClient, JavaAPIClient } from "../lib/apiHelper";
import { createFormDataFromObject } from '../helpers/helpers';

const { get, post, put } = new APIClient();
const { get: _get, post: _post, put: _put } = new JavaAPIClient();

export default {
    /**
     * 이메일 인증
     * @method GET
     * @param {STRING} email
     */
    emailAuth: email => _get(`/auth/email-auth?email=${email}`),

    /**
     * 이메일 인증 코드 확인
     * @method GET
     * @param {STRING} email
     * @param {STRING} code
     */
    emailAuthConfirm: (email, code) => _get(`/auth/email-auth-confirm?email=${email}&code=${code}`),

    /**
     * 이메일 존재 여부 확인
     * @method GET
     * @param {STRING} email
     */
    isExistEmail: email => _get(`/auth/is-exist-email?email=${email}`),

    /**
     * 이메일 존재 여부 확인 return object
     * @method GET
     * @param {STRING} email
     */
    isExistEmail2: email => get(`/auth/is-exist-email2?email=${email}`),

    /**
     * 회원 가입
     * @method POST
     * @param {OBJECT} user
     * =========================
     * @param {STRING} email
     * @param {STRING} password
     * @param {STRING} name
     */
    register: user => _post("/auth/register", user),

    /**
     * 로그인
     * @method POST
     * @param {STRING} email
     * @param {STRING} password
     */
    login: user => _post("/auth/login", user),
    logout: user => _put('/auth/logout'),

    /**
     * @method POST
     * @param user
     */
    biometricLogin: user => _post("/auth/biometric-login", user),

    /**
     * @method POST
     * @param user
     */
    registerDevice: user => _post("/auth/register-device", user),

    /**
     * 내정보 가져 오기
     * @method GET
     * no-params
     */
    me: () => _get("/auth/me"),

    /**
     * 비밀번호 찾기 이메일 인증
     * @method GET
     * @param {STRING} email
     */
    forgetPassword: (email,domainUrl) => _get(`/auth/forget-password?email=${email}&domainUrl=${domainUrl}`),

    /**
     * 비밀번호 찾기 이메일 인증
     * @method GET
     * @param {STRING} email
     * @param {STRING} code
     */
    forgetPasswordConfirm: (email, code) => _get(`/auth/forget-password-confirm?email=${email}&code=${code}`),

    /**
     * 비밀번호 찾기 이메일 인증
     * @method GET
     * @param {STRING} email
     * @param {STRING} password
     */
    /**
     * 로그인 상태 비밀번호 확인 (토큰의 사용자 기준)
     * @method POST
     * @param {STRING} password
     */
    verifyPassword: password => _post("/auth/verify-password", { password }),

    changePassword: (email, password) => {
        const dummy = password.split("").reverse().join("")
        const passwordData = { email, password, dummy }

        return _put("/auth/change-password", passwordData)
    },

    /**
     * 직원 초대
     * @method POST
     * @param {OBJECT} user
     */
    inviteUser: user => post("/invite", user),

    /**
     * 직원 초대
     * @method POST
     * @param {STRING} code
     */
    getInviteCode: code => _get("/invite?code=" + code),

    /**
     * 회사 참여 코드
     */
    joinCodeCompany: code => _get("/auth/joinCodeCompany?code=" + code),

    /**
     * 근태 보고 메일링
     */
    attendReportMail: (companyId, email, date) => get("/auth/attendReportMail?companyId="+companyId+"&email="+email+"&date="+date),

    /**
     * 근태 보고 메일링2
     */
    attendReportMail2: (datas) => _post("/auth/attendReportMail2",datas),

    /**
     *
     */
    attendReportExcel: (companyId, sdate, edate, type) => get("/auth/attendReportExcel?companyId="+companyId+"&sdate="+sdate+"&edate="+edate+"&type="+type ),

    /**
     * 세션 체크
     */
    check: () => _get("/auth/check"),

    /**
     * azure oauth login
     */
    azureLogin: params => _post('/auth/azureLogin', params),

    /**
     * simple oauth login
     */
    simpleLogin: email => _post(`/auth/simpleLogin?email=${email}`),

    /**
     * 단순한 SSO 인증 처리 프로세스
     * @method POST
     */
    simpleSso: (data, signature) => {
      const payload = createFormDataFromObject({ data, signature });

      return _post('/auth/simple-sso', payload);
    },
}
